import SiteSearchResultsAsync from './SiteSearchResultsAsync';

export default SiteSearchResultsAsync;
